import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from "rxjs";
import { tap } from 'rxjs/operators';

import { PropertiesService } from '@core/services/properties.service';
import { StorageService } from '@core/services/storage.service';
import { UserService } from '@core/services/user.service';
import { environment } from '@env/environment';

import { TokenModel } from '@shared/models/token.model';

const authUrl = `${environment.apiBaseUrl}platform/sessions`;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private userService: UserService,
    private propertiesService: PropertiesService,
    private injector: Injector
  ) { }

  goTo(url: string): void {
    const router = this.injector.get(Router);

    router.navigateByUrl(url);
  }

  logOut(): void {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });
    this.http.delete(authUrl, {headers}).subscribe(() => {
      const keyToKeep = 'selectedColumns';

      Object.keys(localStorage).forEach(key => {
        if (key !== keyToKeep) {
          localStorage.removeItem(key);
        }
      });
      this.goTo(this.propertiesService.PLAYGROUND ? '/playground-register' : '/login');
    }, error => {
      console.log('error on logout', error);
    })
  }

  hasToken(): boolean {
    return !!this.storageService.get('access_token');
  }

  getAuthorizationToken(): string | null {
    return this.storageService.get('access_token');
  }

  login(loginFormData: Session.LoginFormModel): Observable<HttpResponse<TokenModel>> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    return this.http.post<any>(authUrl, loginFormData, { headers })
      .pipe(
        tap((response: any) => {
          this.storageService.set('access_token', response.token);
          this.storageService.set('refresh_token', response.refreshToken);
          this.userService.getAuthenticatedUser().subscribe((res) => {
            window.location.href = res.passwordChanged ? '/home' : '/password-change';
          });
        })
      );
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.storageService.get('refresh_token');
    if (refreshToken === null) {
      return throwError(new Error('No refresh token available'));
    }
    return this.http.post<any>(`${authUrl}/refresh`, { refreshToken })
      .pipe(
        tap((response: any) => {
          this.storageService.set('access_token', response.token);
          this.storageService.set('refresh_token', response.refreshToken);
        })
      );
  }
}
